module.exports = __webpack_public_path__ + "img/Play_Circle.1e85ec58.svg";